import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import './_otp-input.scss'

// One box per digit: typing moves forward, backspace moves back and a pasted code fills the boxes
function OtpInput({ length = 6, value = '', onChange = () => {}, label }) {
  const refs = useRef([]);
  const digits = Array.from({ length }, (_, i) => value[i] || '');

  const update = (next) => onChange(next.join('').slice(0, length));

  const handleChange = (i, e) => {
    const typed = e.target.value.replace(/\D/g, '');
    if (!typed) return;
    const next = [...digits];
    typed.split('').slice(0, length - i).forEach((digit, offset) => { next[i + offset] = digit });
    update(next);
    refs.current[Math.min(i + typed.length, length - 1)]?.focus();
  }

  const handleKeyDown = (i, e) => {
    if (e.key !== 'Backspace') return;
    e.preventDefault();
    const next = [...digits];
    if (next[i]) {
      next[i] = '';
    } else if (i > 0) {
      next[i - 1] = '';
      refs.current[i - 1]?.focus();
    }
    update(next);
  }

  return (
    <div className="otp-input" role="group" aria-label={label}>
      {digits.map((digit, i) => (
        <input
          key={i}
          ref={el => { refs.current[i] = el }}
          className="otp-input__box"
          inputMode="numeric"
          autoComplete={i === 0 ? 'one-time-code' : 'off'}
          value={digit}
          onChange={e => handleChange(i, e)}
          onKeyDown={e => handleKeyDown(i, e)}
          onFocus={e => e.target.select()}
          aria-label={`${label} ${i + 1}`}
          data-testid={`otp-digit-${i}`}
        />
      ))}
    </div>
  )
}

OtpInput.propTypes = {
  length: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string
}

export default OtpInput
